"use strict";
var Observable_1 = require('../../Observable');
var mergeAll_1 = require('../../operator/mergeAll');
Observable_1.Observable.prototype.mergeAll = mergeAll_1.mergeAll;
//# sourceMappingURL=mergeAll.js.map


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/~/rxjs/add/operator/mergeAll.js
// module id = ../../../../rxjs/add/operator/mergeAll.js
// module chunks = 3